import authority from './authority';

const path = '/operation'

const operation = (url: string) => () => ({
  authority: authority(url + path),
});

export default operation;